<template lang="pug">
page-template.px-lg-15(:title="title", fluid)
  grid-container(cols="auto", cols-md="auto 270px", gap="40px")
    div
      slot(name="top")
      template(v-if="!loading")
        grid-list.mt-4(:col-width="itemsColWidth")
          slot(name="items")
            v-alert(type="info", color="grey", width="max-content") {{ noDataText }}
        v-pagination.mt-4(
          v-if="showPagination && pagesLength",
          :value="page",
          @input="changePage",
          :length="pagesLength",
          :total-visible="pagesTotalVisible"
        )
      .py-10.d-flex.justify-center(v-else)
        v-progress-circular(size="50", color="primary", indeterminate)
    slot(name="side")
</template>

<script>
import PageTemplate from "./Page.vue";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    pagesLength: {
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    pagesTotalVisible: {
      type: Number,
      default: 3,
    },
    noDataText: {
      type: String,
      default: "Nenhum conteúdo disponível.",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemsColWidth: {
      type: String,
      default: "300px",
    },
  },
  computed: {
    showPagination() {
      const items = this.$slots.items;
      return items && items.length;
    },
  },
  methods: {
    changePage(v) {
      const query = { ...this.$route.query };
      query.p = v;
      this.$router.push({ query });
    },
  },
  components: {
    PageTemplate,
  },
};
</script>
